const ColorInput = ({ label, name, value, onChange }) => (

    <label>
        {label}:
        <input type="color" name={name} value={value} onChange={onChange} />
    </label>

);

export default ColorInput;
